/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*************************************!*\
  !*** ./src/assets/js/quick-view.js ***!
  \*************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function () {
  function docReady(fn) {
    // see if DOM is already available
    if (document.readyState === "complete" || document.readyState === "interactive") {
      // call on next available tick
      setTimeout(fn, 1);
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  docReady(function () {
    if (!customElements.get('quick-view')) {
      var QuickView = /*#__PURE__*/function (_HTMLElement) {
        _inherits(QuickView, _HTMLElement);

        var _super = _createSuper(QuickView);

        function QuickView() {
          var _this;

          _classCallCheck(this, QuickView);

          _this = _super.call(this);
          _this.modalContent = _this.querySelector('.quick-view-modal');

          try {
            // for desktop
            _this.opener = document.querySelector('[aria-controls="'.concat(_this.dataset.opener, '"]')); // for mobile

            _this.opener_2 = document.querySelector('[ariaa-controls="'.concat(_this.dataset.opener, '"]'));
          } catch (error) {} // this.closer = this.querySelector('.popup_close_icon');


          if (_this.opener) {
            _this.opener.setAttribute('aria-haspopup', "dialog");

            _this.opener_2.setAttribute('aria-haspopup', "dialog");

            _this.opener.removeAttribute('hidden');

            _this.opener_2.removeAttribute('hidden');

            _this.modal = _this.querySelector('#'.concat(_this.opener.getAttribute('aria-controls')));

            _this.opener.addEventListener('click', function (event) {
              event.preventDefault();

              _this.open(_this.opener);
            });

            _this.opener_2.addEventListener('click', function (event) {
              event.preventDefault();

              _this.open(_this.opener_2);
            });
          }

          _this.closer = _this.querySelectorAll('.popup_close_icon');

          if (_this.closer && _this.modal) {
            _this.closer.forEach(function (el) {
              return el.addEventListener('click', function (event) {
                _this.close();
              });
            });
          }

          _this.related_item = _this.querySelectorAll('.data-relative');

          if (_this.related_item) {
            _this.related_item.forEach(function (el) {
              return el.addEventListener('click', _this.toggleRelative.bind(_assertThisInitialized(_this)));
            });
          } // this.setupSlider();


          return _this;
        }

        _createClass(QuickView, [{
          key: "toggleRelative",
          value: function toggleRelative(event) {
            event.preventDefault();
            var target = event.currentTarget;
            var div = target.getAttribute('data-target');
            var copyThis= this;
            var secondLevelBundles=this.querySelectorAll('.second_level_bundle');
            if(secondLevelBundles){
              secondLevelBundles.forEach(function(bundle) {
                var productBundleOption=  bundle.querySelector('.pdp-select-sec .product_bundle_option');
                if(productBundleOption){
                  var anchorTags = productBundleOption.querySelectorAll('a');
                  anchorTags.forEach(function(anchorTag) {
                    var dataTarget= anchorTag.getAttribute('data-target');
                    var modalPane = copyThis.querySelector('.quick-modal-main-sec .'.concat(dataTarget));
                    if(!modalPane){
                      anchorTag.classList.add('hidden');
                    }
                  });
                }
              });
            }
            var pane = this.querySelector('.quick-modal-main-sec .'.concat(div));
            if(pane){
            this.querySelectorAll('.bundle-pane').forEach(function (el) {
              return el.classList.add('hidden');
            });
            pane.classList.toggle('hidden');
            this.setupSlider(pane);
            }
            document.dispatchEvent(new Event('shopify:section:load'));
            window.dispatchEvent(new Event('scroll'));
          }
        }, {
          key: "open",
          value: function open(triggeredBy) {
            var _this2 = this;

            if (triggeredBy) this.setActiveElement(triggeredBy);
            setTimeout(function () {
              _this2.loadContent();

              _this2.modal.removeAttribute('hidden');

              _this2.modalContent.classList.remove('duration-200', 'opacity-0', 'translate-y-4', 'sm:translate-y-0', 'sm:scale-95');

              _this2.modalContent.classList.add('ease-out', 'duration-300');

              var firstProductBlock = _this2.querySelector('.first-product-block');

              _this2.setupSlider(firstProductBlock);

              setTimeout(function () {
                _this2.modalContent.classList.add('opacity-100', 'translate-y-0', 'sm:scale-100');
              }, 20);
            });
            document.body.classList.add('overflow-hidden', 'modal-open');
          }
        }, {
          key: "close",
          value: function close() {
            var _this3 = this;

            setTimeout(function () {
              _this3.modalContent.classList.remove('duration-300', 'opacity-100', 'translate-y-0', 'sm:scale-100');

              _this3.modalContent.classList.add('ease-out', 'duration-200');

              setTimeout(function () {
                _this3.modalContent.classList.add('opacity-0', 'translate-y-4', 'sm:translate-y-0', 'sm:scale-95');
              });
            });
            this.modalContent.addEventListener('transitionend', function () {
              _this3.modal.setAttribute('hidden', '');
            }, {
              once: true
            });
            document.body.classList.remove('overflow-hidden', 'modal-open');
            setTimeout(function () {
              _this3.querySelectorAll('.bundle-pane').forEach(function (el) {
                return el.classList.add('hidden');
              });

              _this3.querySelector('.first-product-block').classList.remove('hidden');
            }, 500);
             var content = this.querySelector('template').outerHTML;
            this.modalContent.querySelector('.modal-content').innerHTML = content;
          }
        }, {
          key: "setupSlider",
          value: function setupSlider(block) {
            if (block.querySelector('.pdp-slider-main-1')) {
              this.swiper1 = new Swiper(block.querySelector('.pdp-slider-main-1'), {
                scrollbar: {
                  el: block.querySelector(".pdp-main-slider-scrollbar-1"),
                  draggable: true
                },
                slidesPerView: "1",
                spaceBetween: 0,
                navigation: {
                  nextEl: block.querySelector(".swiper-button-next-1"),
                  prevEl: block.querySelector(".swiper-button-prev-1")
                },
                breakpoints: {
                  0: {
                    slidesPerView: "1",
                    spaceBetween: 0
                  },
                  900: {
                    slidesPerView: "1"
                  },
                  1024: {
                    slidesPerView: 1
                  }
                },
                on: {
                  slideChange: function (swiper1) {
                    var slide = swiper1.slides[swiper1.activeIndex];

                    if (this.video && !this.video.paused) {
                      this.video.pause();
                    }

                    this.video = slide.querySelector('video');

                    if (this.video) {
                      this.video.play();
                    }
                  }.bind(this)
                }
              });
              this.swiper2 = new Swiper(block.querySelector('.pdp-slider-main-2'), {
                scrollbar: {
                  el: block.querySelector(".pdp-main-slider-scrollbar-2"),
                  draggable: true
                },
                slidesPerView: "1",
                spaceBetween: 0,
                navigation: {
                  nextEl: block.querySelector(".swiper-button-next-2"),
                  prevEl: block.querySelector(".swiper-button-prev-2")
                },
                breakpoints: {
                  0: {
                    slidesPerView: "1",
                    spaceBetween: 0
                  },
                  900: {
                    slidesPerView: "1"
                  },
                  1024: {
                    slidesPerView: 1
                  }
                },
                on: {
                  slideChange: function (swiper2) {
                    var slide = swiper2.slides[swiper2.activeIndex];

                    if (this.video && !this.video.paused) {
                      this.video.pause();
                    }

                    this.video = slide.querySelector('video');

                    if (this.video) {
                      this.video.play();
                    }
                  }.bind(this)
                }
              });
            }
          }
        }, {
          key: "loadContent",
          value: function loadContent() {
            var _this4 = this;

            if (!this.getAttribute('loaded')) {
              var content = this.querySelector('template').content.cloneNode(true);
              this.modalContent.querySelector('.modal-content').appendChild(content);
              setTimeout(function () {
                var firstProductBlock = _this4.querySelector('.first-product-block');

                _this4.setupSlider(firstProductBlock);

                _this4.closer = _this4.querySelectorAll('.popup_close_icon');

                if (_this4.closer && _this4.modal) {
                  _this4.closer.forEach(function (el) {
                    return el.addEventListener('click', function (event) {
                      _this4.close();
                    });
                  });
                }

                _this4.related_item = _this4.querySelectorAll('.data-relative');

                if (_this4.related_item) {
                  _this4.related_item.forEach(function (el) {
                    return el.addEventListener('click', _this4.toggleRelative.bind(_this4));
                  });
                }
              }, 20);
              // this.setAttribute('loaded', true);
            }
          }
        }, {
          key: "setActiveElement",
          value: function setActiveElement(element) {
            this.activeElement = element;
          }
        }]);

        return QuickView;
      }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

      customElements.define('quick-view', QuickView);
    }
  });
})();
/******/ })()
;